import { render, staticRenderFns } from "./SearchSettingsAddColumnModal.vue?vue&type=template&id=79d73e14"
import script from "./SearchSettingsAddColumnModal.vue?vue&type=script&lang=ts"
export * from "./SearchSettingsAddColumnModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79d73e14')) {
      api.createRecord('79d73e14', component.options)
    } else {
      api.reload('79d73e14', component.options)
    }
    module.hot.accept("./SearchSettingsAddColumnModal.vue?vue&type=template&id=79d73e14", function () {
      api.rerender('79d73e14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/browse/SearchSettingsAddColumnModal.vue"
export default component.exports